import "./WorldMap.css";
import "leaflet/dist/leaflet.css";
import "./leafletRotate";

import { MAP_MODES, MAP_TILE_LAYERS } from "../constants";
import { MapContainer, TileLayer } from "react-leaflet";

import LoadingImg from "../components/loading";
import PropTypes from "prop-types";
import { Row } from "reactstrap";
import { TrialDisplay } from "./TrialDisplay";
import { TrialMarkerCluster } from "./TrialMarkerCluster/TrialMarkerCluster";
import mapbg from "../static/img/worldmap_background.png";
import { useSelector } from "react-redux";

const MIN_ZOOM = 3;
const MAX_ZOOM = 30;

export const WorldMap = ({
  mapMode,
  mapRef,
  selectedTileLayer = MAP_TILE_LAYERS.SATELLITE,
}) => {
  const [trial, refreshing] = useSelector(({ resultMap }) => [
    resultMap.trial,
    resultMap.refreshing,
  ]);

  return (
    <Row className="flex-grow-1">
      <MapContainer
        attributionControl={false}
        ref={mapRef}
        center={[26.0, 30.0]}
        zoom={MIN_ZOOM}
        minZoom={MIN_ZOOM}
        maxZoom={MAX_ZOOM}
        zoomControl={false}
        maxBounds={[
          [-85, -180],
          [85, 180],
        ]}
        maxBoundsViscosity={1.0}
        rotate
        rotateControl={false}
        style={{
          backgroundImage: `url(${mapbg})`,
          backgroundSize: "1300px",
        }}
      >
        {trial && mapMode === MAP_MODES.TRIAL ? (
          <TrialDisplay />
        ) : (
          <TrialMarkerCluster />
        )}
        {selectedTileLayer && (
          <TileLayer
            url={selectedTileLayer.url}
            maxNativeZoom={18}
            maxZoom={MAX_ZOOM}
            zIndex={0}
          />
        )}
      </MapContainer>
      {/* Prevent user actions while loading trial */}
      {refreshing && <LoadingImg visible />}
    </Row>
  );
};

WorldMap.propTypes = {
  mapRef: PropTypes.object.isRequired,
  selectedTileLayer: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }),
  mapMode: PropTypes.oneOf(Object.values(MAP_MODES)).isRequired,
};
